module.exports = __webpack_public_path__ + "static/media/ClaireHutchinson-6.7dbf6864.png";